import React from 'react';
import Box from "@mui/material/Box";
import AuthFlowManager from "./AuthFlowManager";
import Typography from "@mui/material/Typography";

interface FormForgotProps {
    prefillEmail?: string;
    onEmailChange?: (email: string) => void;
}

const FormForgot: React.FC<FormForgotProps> = React.memo(({ prefillEmail, onEmailChange }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                flex: 1,
                minHeight: 0 // Allows flex children to shrink below content size
            }}
        >
            {/* Header - Pinned at top */}
            <Box
                sx={{
                    flexShrink: 0,
                    pb: 2
                }}
            >
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Reset Password
                </Typography>
            </Box>

            {/* Form content - Scrollable area with spacing from header */}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0,
                    overflowY: 'auto',
                    pt: 2,
                    pb: 4
                }}
            >
                <AuthFlowManager
                    flowType="forgotPassword"
                    prefillEmail={prefillEmail}
                    onEmailChange={onEmailChange}
                    onStepTransition={(step, error, data) => {
                        // Handle step transitions for forgot password flow
                    }}
                    initialStepConfig={{
                        email: 'enabled',
                        verifyEmail: 'hidden',
                        newPassword: 'hidden',
                        setupMFA: 'hidden',
                        verifyMFA: 'hidden'
                    }}
                />
            </Box>
        </Box>
    );
});

FormForgot.displayName = 'FormForgot';

export default FormForgot;
